import {
  Stepper,
  Step,
  StepLabel,
  Box,
  Button,
  TextField,
  Stack,
  Typography,
  Paper,
  InputBase,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  RadioGroup,
  Table,
  TableBody,
  TableRow,
  TableCell,
  FormControlLabel,
  Radio,
  Chip,
  TableHead,
} from "@mui/material";
import { useEffect, useState } from "react";
import { EditUserForm } from "./EditUserDialog";
import { AccountMenu } from "./AccountMenu";
import { genAccount, newDefaultUser } from "../../services/user/userApi";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import SearchIcon from "@mui/icons-material/Search";
import { useAppDispatch } from "../../app/hooks";
import { addUsers } from "../../features/user/userSlice";
const steps = ["Tạo account", "Thông tin khác"];

export default function AddUserStep({ onCancel, onSave }) {
    const dispatch = useAppDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [user, setUser] = useState({});
  const [checked, setChecked] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [candidateIdx, setCandidateIdx] = useState(-1);

  const handleNext = () => setActiveStep((s) => s + 1);
  const handleBack = () => setActiveStep((s) => s - 1);

  const handleSave = () => {
    onSave(user);
  };
  const handleCheck = async () => {
    // fetch data
    const { result } = await genAccount(user.name);
    if (result) {
    //   console.log(result);
      const newUser = {
        ...newDefaultUser(),
        name: user.name,
        email: result.account,
        isNew: true,
        id: `tmp_${crypto.randomUUID()}`,
      };
      const newCandidates = [newUser, ...result.users];
      dispatch(addUsers(result.users));
      setCandidates(newCandidates);
      setCandidateIdx(0);
      setUser(newUser);
      setChecked(true);
    }
  };
  return (
    <>
      <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <>
          <StepAccount user={user} onChange={setUser} />

          <FormControl fullWidth>
            <RadioGroup
              value={candidateIdx}
              onChange={(_e, v) => {
                const idx = Number(v);
                setCandidateIdx(idx);
                setUser(candidates[idx]);
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell width={48} />
                    <TableCell>Email</TableCell>
                    <TableCell>Birth</TableCell>
                    <TableCell>Thành phần</TableCell>
                    <TableCell>Pháp danh</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {candidates.map((u, i) => (
                    <TableRow
                      key={i}
                      hover
                      selected={candidateIdx === i}
                      onClick={() => {
                        setCandidateIdx(i);
                        setUser(u);
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Radio value={i} />
                      </TableCell>

                      <TableCell>{u.email}</TableCell>
                      <TableCell>{u.birth || "-"}</TableCell>
                      <TableCell>{u.thanhPhan || "-"}</TableCell>
                      <TableCell>{u.phapDanh || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </RadioGroup>
          </FormControl>

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button onClick={handleCheck} disabled={!user.name}>
              Check
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              disabled={!checked}
            >
              Next
            </Button>
          </Box>
        </>
      )}

      {activeStep === 1 && (
        <>
          <EditUserForm
            user={user}
            onChange={(key, value) => {
              setUser((prev) => ({ ...prev, [key]: value }));
            }}
          />

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button onClick={handleBack}>Back</Button>
            <Button variant="contained" onClick={handleSave}>
              Create
            </Button>
          </Box>
        </>
      )}
    </>
  );
}

function StepAccount({ user, onChange }) {
  const update = (key) => (e) =>
    onChange((prev) => ({ ...prev, [key]: e.target.value }));

  return (
    <Stack spacing={2}>
      <TextField
        label="Tên"
        value={user.name || ""}
        onChange={update("name")}
        fullWidth
        required
      />

      <TextField
        label="Account / Username"
        value={user.email || ""}
        onChange={update("email")}
        fullWidth
      />
    </Stack>
  );
}

function UserAccInput({
  value: inValue = "",
  email = "",
  onChange = (_name) => {},
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(inValue);
  }, [inValue]);

  const [candidates, setCandidates] = useState([]);
  const [popupState, showPopup] = useState(false);
  const [selected, setSelected] = useState(null);

  async function genAcc(name) {
    // fetch data
    const { result } = await genAccount(name);
    if (result) {
      console.log(result);
      // setUser({...user, email:result.account})
      const newUser = { ...newDefaultUser(), name, email: result.account };
      const newCandidates = [newUser, ...result.users];
      setCandidates(newCandidates);
      setSelected(0);
      onChange((prev) => ({ ...newUser }));
      if (newCandidates.length > 1) {
        // show popup
        showPopup(true);
      }
    }
  }

  function onSearch(name) {
    genAcc(name);
  }

  return (
    <>
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          width: 400,
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Họ tên"
          inputProps={{ "aria-label": "Họ tên" }}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
        {email && <Chip label={email}></Chip>}
        <IconButton
          type="button"
          sx={{ p: "10px" }}
          aria-label="search"
          onClick={() => onSearch(value)}
        >
          <SearchIcon />
        </IconButton>
        <AccountSelect
          selected={selected}
          candidates={candidates}
          onChange={(i) => {
            setSelected(i);
            onChange((prev) => ({ ...candidates[i] }));
          }}
        ></AccountSelect>
      </Paper>

      <Dialog open={popupState} onClose={() => showPopup(false)}>
        <DialogTitle>{"Select account"}</DialogTitle>
        <DialogContent>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={selected}
              onChange={(_e, v) => {
                const idx = parseInt(v);
                setSelected(idx);
                onChange((prev) => ({ ...candidates[idx] }));
                showPopup(false);
              }}
            >
              <Table>
                <TableBody>
                  {candidates.map((u, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <FormControlLabel
                          value={i}
                          control={<Radio />}
                          label={u.email}
                        ></FormControlLabel>
                      </TableCell>
                      <TableCell>{u.birth || "-"}</TableCell>
                      <TableCell>{u.thanhPhan || "-"}</TableCell>
                      <TableCell>{u.phapDanh || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </RadioGroup>
          </FormControl>
        </DialogContent>
      </Dialog>
    </>
  );
}

function AccountSelect({ selected, candidates, onChange }) {
  const options = candidates.map((u, i) => ({
    onClick: () => {
      onChange(i);
    },
    icon:
      i === selected ? (
        <RadioButtonCheckedIcon fontSize="small" />
      ) : (
        <RadioButtonUncheckedIcon fontSize="small" />
      ),
    label: u.email,
  }));
  return <AccountMenu options={options}></AccountMenu>;
}
